import { defineComponent as _defineComponent } from 'vue'
import {
  useContext,
  useRoute,
  useRouter,
  onMounted,
  ref,
  onBeforeUnmount,
} from '@nuxtjs/composition-api';
import TButton from '~/components/atoms/t-button.vue';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import { pluralise } from '~/utils/formatStrings';
import { usePlusDownloads } from '~/composables/usePlusDownloads';
import { useUser } from '~/composables/useUser';

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadsPill',
  setup(__props) {

const { plusDownloadsLeft } = usePlusDownloads();
const plusDownloadForPlusLite = ref(plusDownloadsLeft.value);
const { $config, i18n, localePath, $isFlagOn, $cookies, $mzAnalyticsApi } = useContext();
const route = useRoute();
const router = useRouter();
const { user, getUserDownloadLimit } = useUser();
const userSubCode = user.value?.subscription?.code;

const useValueChanged = async () => {
  if (user.value && userSubCode === 'plus_lite') {
    const downloadQuota = await getUserDownloadLimit(
      $cookies.get('auth._token.local').replace('Bearer ', '')
    );
    return downloadQuota.download_quota_counter;
  }
};
const trackButtonClick = (eventName: string) => {
  console.log(`${eventName} button clicked`);
  const Name = eventName ? `credit.${eventName}` : 'credit';
  $mzAnalyticsApi({
    event: 'click',
    name: Name,
    productArea: 'hub',
  });
};
onMounted(() => {
  if (window.innerWidth < 1024) {
    window.addEventListener('click', () => {
      if (document.visibilityState === 'visible') {
        useValueChanged().then(value => {
          plusDownloadForPlusLite.value = value;
        });
      }
    });
  } else {
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        useValueChanged().then(value => {
          plusDownloadForPlusLite.value = value;
        });
      }
    });
  }
});
onBeforeUnmount(() => {
  window.removeEventListener('click', () => {});
});
const handleUpgradeButtonClick = () => {
  router.push(localePath('/plans/'));
};

return { __sfc: true,plusDownloadsLeft, plusDownloadForPlusLite, $config, i18n, localePath, $isFlagOn, $cookies, $mzAnalyticsApi, route, router, user, getUserDownloadLimit, userSubCode, useValueChanged, trackButtonClick, handleUpgradeButtonClick, TButton, TLinkButton, pluralise }
}

})